module.exports = __webpack_public_path__ + "img/thumb_18.6205eaf9.jpg";